import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, UrlSerializer } from '@angular/router';
import { environment } from '@env/environment';
import { WindowToken } from './core/window.service';
import { TrailingSlashUrlSerializer } from './shared/url-serializer/url-serializer';
import { Shell } from './shell/shell.service';

const routes: Routes = [
  // The signup and verify routes appear within the "shell" component, which provides
  // a common DPOD header, optional navbar, loading spinner, ContextService, etc.
  Shell.childRoutes([
    {
      path: 'signup',
      loadChildren: () => import('./signup/signup.module').then(m => m.SignupModule),
      data: {
        showNav: true
      }
    },
    {
      path: 'thank-you',
      loadChildren: () => import('./thankyou/thankyou.module').then(m => m.ThankYouModule)
    },
  ]),

  // Fallback when no prior route is matched
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        enableTracing: !(environment.production),
        preloadingStrategy: PreloadAllModules,
      },
    )
  ],
  exports: [RouterModule],
  providers: [
    /* Dynamically set the base href of the Angular router from the browser address bar. This is
     * needed because the gangplank application can be accessed from several client-facing URLs
     * (`/thank-you/` and `/signup/`), so the base href as seen by the Angular router
     * will change depending on which URL the client has loaded.
     * Note that this dynamic behavior only affects the Angular router. The static files are always
     * loaded from /signup/main.xxxxxx.js due to the baseHref set in angular.json.
     */
    {
      provide: APP_BASE_HREF,
      deps: [WindowToken],
      useFactory: baseHrefFactory
    },
    {
      provide: UrlSerializer,
      useClass: TrailingSlashUrlSerializer,
    },
  ]
})
export class AppRoutingModule { }

/**
 * @returns The base path dynamically obtained from the browser address bar.
 */
export function baseHrefFactory(window: Window) {
  return window.location.pathname.split('/')[0];
}
